// Helpers para o Meta Pixel (Facebook Ads).
// O snippet base fica em public/index.html e já registra o PageView inicial.
// Como o app é uma SPA (react-router, sem reload de página), é preciso disparar
// o PageView manualmente a cada troca de rota — ver App.jsx.

const isPixelLoaded = () => typeof window !== 'undefined' && typeof window.fbq === 'function';

// Disparar em toda troca de rota da SPA (exceto a carga inicial, já coberta pelo snippet base).
export const trackPageView = () => {
  if (!isPixelLoaded()) return;
  window.fbq('track', 'PageView');
};

// Disparar apenas no callback de sucesso da verificação de cadastro de COMPRADOR.
// Não deve ser usado no fluxo de cadastro de lojista/vendedor.
export const trackCompleteRegistration = () => {
  if (!isPixelLoaded()) return;
  window.fbq('track', 'CompleteRegistration');
};
